export default __webpack_public_path__ + "static/media/carouselImage1.3d864f3a.png";